import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';

import validateName from './validateName';
import validateDuration from './validateDuration';
import validateAvatar from './validateAvatar';

function validateScenario(caseConf) {
  const validationResults = [
    validateName(caseConf),
    validateDuration(caseConf),
    validateAvatar(caseConf),
  ];
  return mergeWith({}, ...validationResults, (objValue, srcValue) => {
    if (isArray(objValue)) {
      return objValue.concat(srcValue);
    }
    return undefined;
  });
}

export default validateScenario;
